import { httpRepo } from "configurations/axios";
import {
  VOUCHER_DUPLICATE_START,
  VOUCHER_DUPLICATE_SUCCESS,
  VOUCHER_DUPLICATE_ERROR,
  CLEAR_DUPLICATE_VOUCHER
} from "../types/duplicateVoucherType";

export const fetchDuplicateVoucher = (voucherId) => async (dispatch) => {
  try {
    dispatch({ type: VOUCHER_DUPLICATE_START });
    const response = await httpRepo.get(
      `/asignacion/comprobante/cufe/${voucherId}`,
    );
    if (response.status !== 200) throw new Error("Error obteniendo la factura");

    const data = await response.data;

    dispatch({ type: VOUCHER_DUPLICATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: VOUCHER_DUPLICATE_ERROR, payload: error.message });

  }
};

export const clearDuplicateVoucher = () => ({
  type: CLEAR_DUPLICATE_VOUCHER,
});